/*
 * @Author: qh_feng
 * @Date: 2022-03-17 17:22:49
 * @LastEditTime: 2022-03-28 12:11:10
 * @LastEditors: your name
 * @Description: 
 * @ FilePath: Do not edit
 * @par 修改日志:
 * 内容:  预警布控 API
 */
export default {
  //布控管理
  POST_hyDispositionAdd: '/dqi-hymanage/hyDisposition/add',
  DELETE_hyDispositionDelete: '/dqi-hymanage/hyDisposition/delete/',
  GET_hyDispositionFind: '/dqi-hymanage/hyDisposition/find/',
  POST_hyDispositionList: '/dqi-hymanage/hyDisposition/list',
  PUT_hyDispositionUpdate: '/dqi-hymanage/hyDisposition/update',
  //布控告警
  POST_hyNotificationPage: '/dqi-hymanage/hyNotification/page',
  GET_hyNotificationFind: '/dqi-hymanage/hyNotification/find/',
}


// WEBPACK FOOTER //
// ./src/http/apiModules/yjbk.js